import React, { useEffect, useState, lazy } from 'react';
import { Button } from '../UI/Button';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface HeroProps {
  openRegistrationForm?: () => void;
  openHostSalonForm?: () => void;
  openPaymentForm?: () => void;
  scrollToAccessPoints?: () => void;
}
export const Hero = ({
  openRegistrationForm,
  openHostSalonForm,
  openPaymentForm,
  scrollToAccessPoints
}: HeroProps) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const slides = [{
    title: 'We are retooling culture shapers with tools to help them launch their ideas, Fast!',
    description: 'A high-trust, multi-city ecosystem combining AI and digital skills training, authority-building masterclasses, networking salons, and opportunity matching across Nigeria, Germany, and Namibia.',
    buttonText: "Join Today for ₦20,000 (Founder's Offer)",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uYUDzrQ7Ktb22QfCxayyYV/dfgs.png'
  }, {
    title: 'We are Building a High Trust Ecosystem for Culture Shapers',
    description: 'Practical digital skills, a network you can actually reach, and real access to jobs, partnerships, funding, and mentorship — across cities in Nigeria, Germany, and Namibia.',
    buttonText: "Join Today for ₦20,000 (Founder's Offer)",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vCt2gb8pCBefdiGMq8vPjo/SAV_8449.jpg'
  }];
  // Typewriter effect for hero title
  useEffect(() => {
    const fullText = slides[currentSlide].title;
    setDisplayedText('');
    setIsTyping(true);
    let charIndex = 0;
    const typingInterval = setInterval(() => {
      if (charIndex < fullText.length) {
        setDisplayedText(fullText.slice(0, charIndex + 1));
        charIndex++;
      } else {
        clearInterval(typingInterval);
        setIsTyping(false);
      }
    }, 35); // Speed: 35ms per character
    return () => clearInterval(typingInterval);
  }, [currentSlide]);
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? slides.length - 1 : prev - 1);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 7000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative min-h-screen flex items-center border-b border-gray-200" data-id="element-455" data-mp="1nq5hvot3dx95">
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-456" data-mp="1ir2o50ikbdgh">
        {slides.map((slide, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${currentSlide === index ? 'opacity-100' : 'opacity-0'}`} data-id="element-457" data-mp="1dt14oeh85c4h" data-mpi={index}>
            <img src={slide.image} alt={`The Networking Salon - Slide ${index + 1}`} className="w-full h-full object-cover grayscale" loading={index === 0 ? 'eager' : 'lazy'} style={{
          maxWidth: '100%',
          height: 'auto'
        }} data-id="element-458" data-mp="14rb34ftmowsz" />
            <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-459" data-mp="3pgntyatvz8v0"></div>
          </div>)}
      </div>
      <div className="container mx-auto px-4 py-16 relative z-10" data-id="element-460" data-mp="3ucv1g81xksf2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-461" data-mp="2wsi81kr3jdtl">
          <div className="order-2 lg:order-1" data-id="element-462" data-mp="31pihm5n5mypg">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-white min-h-[4em]" data-id="element-463" data-mp="31o7d23lvxmxa">
              {displayedText}
              <span className={`inline-block w-[3px] h-[1em] ml-1 align-middle ${isTyping ? 'animate-pulse' : 'opacity-0'}`} style={{
              backgroundColor: '#ff6b35'
            }} data-id="element-464" data-mp="3bglib6c69bo7"></span>
            </h1>
            <p className={`mt-6 text-xl text-gray-200 transition-opacity duration-500 ${!isTyping ? 'opacity-100' : 'opacity-0'}`} data-id="element-465" data-mp="2ixfwoi3hcw9e">
              {slides[currentSlide].description}
            </p>
            <div className={`mt-8 flex flex-wrap gap-4 transition-all duration-500 ${!isTyping ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} data-id="element-466" data-mp="y93s1qd5pnpn">
              <Button onClick={scrollToAccessPoints} data-id="element-467" data-mp="187jevh55iatc">
                {slides[currentSlide].buttonText}
              </Button>
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-468" data-mp="137ygb7tw84h5">
            <div className="h-20 lg:h-80" data-id="element-469" data-mp="1h7zgel2c37vk"></div>
          </div>
        </div>
      </div>
      <button onClick={prevSlide} className="absolute left-4 top-1/2 transform -translate-y-1/2 p-2 bg-white/20 hover:bg-white/30 rounded-full border border-white/30 btn-magnetic" aria-label="Previous slide" data-id="element-470" data-mp="1c950prznxzfo">
        <ChevronLeft size={24} className="text-white" data-id="element-471" data-mp="3e1kt0ezqvrmw" />
      </button>
      <button onClick={nextSlide} className="absolute right-4 top-1/2 transform -translate-y-1/2 p-2 bg-white/20 hover:bg-white/30 rounded-full border border-white/30 btn-magnetic" aria-label="Next slide" data-id="element-472" data-mp="1tiqu9cc2npac">
        <ChevronRight size={24} className="text-white" data-id="element-473" data-mp="1kpdtjo7rnjdp" />
      </button>
      <div className="absolute bottom-8 left-0 right-0 flex justify-center gap-2" data-id="element-474" data-mp="1or8ped6xh4k3">
        {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full border border-white transition-all duration-300 ${currentSlide === index ? 'bg-white scale-125' : 'bg-white/30 hover:bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-475" data-mp="1aqy37ngkce59" data-mpi={index} />)}
      </div>
    </section>;
};